module.exports = __webpack_public_path__ + "img/tv.d78bd31.svg";